import { FormWithFieldsShape } from './types'
import DisplayFields from './DisplayFields'
import React from 'react'

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'FC'.
const PersonalForm: FC<FormWithFieldsShape> = ({ fields, mobile }) => {
  const { email, firstName, lastName, homePhone, document } = fields

  return (
    <div>
      <div>{email}</div>
      <div>{firstName}</div>
      <div>{lastName}</div>
      <DisplayFields
        mobile={mobile}
        firstField={homePhone}
        secondField={document}
      />
    </div>
  )
}

export default PersonalForm
